import { ISnackbarContextProps } from '../constants/types';
import { createContext } from 'react';

const SnackbarContext = createContext<ISnackbarContextProps | null>(null);

export default SnackbarContext;
